// The brand mark is a bitmap (the gold glass-panel render), so it is served as a PNG
// rather than drawn as SVG. It is artwork on a near-black field: the keyed transparency
// drops its dark glass out, so it is only ever placed on a dark surface — the navbar, the
// footer, the admin bar and the email header are all navy for exactly that reason.
export default function Logo({ size = 40 }) {
  return (
    <span className="logo">
      <img
        className="logo-mark"
        src="/brand/logo.png"
        srcSet="/brand/logo.png 1x, /brand/logo@2x.png 2x"
        height={size}
        alt=""
        aria-hidden="true"
      />
      <span className="logo-text">
        <strong>LEVEL UP</strong>
        <small>GLASS SUPPLY</small>
      </span>
    </span>
  )
}
